"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const differenceInMinutes_1 = __importDefault(require("date-fns/differenceInMinutes"));
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const mobx_1 = require("mobx");
const getFleetQuote_1 = __importDefault(require("../clients/fleetquote/getFleetQuote"));
const API_STATE_1 = __importDefault(require("../constants/app/API_STATE"));
const STORAGE_KEYS_1 = __importDefault(require("../constants/app/STORAGE_KEYS"));
const QUOTE_API_ERROR_CODES_1 = __importDefault(require("../constants/errorCodes/QUOTE_API_ERROR_CODES"));
const fleetQuoteFactory_1 = __importDefault(require("../factories/fleetquote/fleetQuoteFactory"));
const session_storage_service_1 = __importDefault(require("../services/session.storage.service"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**
 * Fleet Quote Domain Store
 * Stores data related to fleet quote
 * To be called inside Fleet Details Dialog
 */
class FleetQuoteStore {
    constructor(initialState) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        // there might be a better way to handle this later
        // may be move this logic inside promoCode store itself.
        this.appliedPromoCode = ''; // observable to store the applied promo code with fleet quote
        /**
         * Fetches fleet quote data from backend
         * @param searchId {string}
         * @param groupId {number}
         * @param reqParams {}
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (searchId, groupId, reqParams, errorHandler, successHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                // make fleet quote api call
                const fleetQuoteResponse = yield (0, getFleetQuote_1.default)(searchId, groupId, reqParams);
                // for 200 http status
                this.onSuccess(fleetQuoteResponse, reqParams, successHandler);
            }
            catch (err) {
                // for all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback for fleet quote
         * @param {FleetQuoteType} data
         */
        this.onSuccess = (data, reqParams, successHandler) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
            // set fleet quote in session storage.
            session_storage_service_1.default.set(STORAGE_KEYS_1.default.FLEET_QUOTE, data);
            // update applied promo observable code if it was applied or removed
            const promoCode = (0, get_1.default)(reqParams, 'promoCode', '');
            this.appliedPromoCode = promoCode;
            // find from req params if promo is removed by user
            const isPromoRemoved = (0, get_1.default)(reqParams, 'removed', false);
            // promo can be auto applied or manually applied
            // can have all discount, online discount or both
            const hasAllDiscount = !(0, isEmpty_1.default)((0, get_1.default)(data, `priceDetails.allDiscountDetails`, {}));
            const hasOnlineDiscount = !(0, isEmpty_1.default)((0, get_1.default)(data, `priceDetails.onlineDiscountDetails`, {}));
            // if an auto applied promo is on, then update observable
            // fleet details page where it makes quote api, is only concerned
            // with all discounts field.
            if ((hasAllDiscount || hasOnlineDiscount) && !isPromoRemoved) {
                const discountPromo = (0, get_1.default)(data, `priceDetails.promotionDetails.code`, '');
                this.appliedPromoCode = discountPromo;
            }
            if (successHandler) {
                const quoteId = (0, get_1.default)(data, 'quoteId', '');
                successHandler(quoteId);
            }
        };
        /**
         * on error callback for fleet quote
         * @param {AxiosError} err
         * @param {ErrorHandlerType} errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            const errResponse = err.response;
            if (errResponse) {
                const { data, status } = errResponse;
                const errorCode = data && data.code;
                /**
                 * set data when fleet quote api gives different error
                 * when quote api return Invalid Insurance error code(TF3006)
                 * when quote api return Invalid Addon error code(TF3005)
                 * when quote api return Invalid PromoCode error code(TF3008)
                 */
                if (errorCode === QUOTE_API_ERROR_CODES_1.default.TF3006 ||
                    errorCode === QUOTE_API_ERROR_CODES_1.default.TF3005 ||
                    errorCode === QUOTE_API_ERROR_CODES_1.default.TF3008) {
                    // get prev fleet quote from session storage.
                    const fleteQuote = session_storage_service_1.default.get(STORAGE_KEYS_1.default.FLEET_QUOTE);
                    this.data = fleteQuote;
                }
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Action to explicitly set the applied promo code
         * will be used by FE to negate applied code when necessary
         * @param {string} code
         */
        this.setAppliedPromoCode = (code = '') => {
            this.appliedPromoCode = code;
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**
     * Returns true if API state is loading
     * @returns {boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns true if API fetch was success
     * @returns {boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns true if API fetch has failed
     * @returns {boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns true if API fetch returned no data
     * @returns {boolean}
     */
    get hasNoData() {
        return this.isSuccess && (0, isEmpty_1.default)(this.data);
    }
    /**
     * Returns formatted fleet price from quote call
     * @returns {Object}
     */
    get fleetQuote() {
        return (0, fleetQuoteFactory_1.default)(this.data);
    }
    get hasAllDiscount() {
        return (this.isSuccess &&
            !(0, isEmpty_1.default)((0, get_1.default)(this.data, `priceDetails.allDiscountDetails`, {})));
    }
    get hasOnlineDiscount() {
        return (this.isSuccess &&
            !(0, isEmpty_1.default)((0, get_1.default)(this.data, `priceDetails.onlineDiscountDetails`, {})));
    }
    get hasAnyDiscount() {
        return this.isSuccess && (this.hasAllDiscount || this.hasOnlineDiscount);
    }
    /**
     * Returns quoteID
     * @returns {string}
     */
    get quoteId() {
        return (0, get_1.default)(this.fleetQuote, 'quoteId');
    }
    /**
     * Returns quote expiry
     * @returns {Date} Epoch time stamp eg. JS Time/1000
     */
    get expiry() {
        return (0, get_1.default)(this.fleetQuote, 'expiry');
    }
    /**
     * Returns the expiry time in mins as compared to now
     * @returns {number}
     */
    get expiryMins() {
        // this.expiry will always be in future
        return (0, differenceInMinutes_1.default)(new Date(this.expiry * 1000), Date.now());
    }
    /**
     * Returns Rewards Options Details
     * @returns {any}
     */
    get rewardsOptions() {
        return (0, get_1.default)(this.fleetQuote, 'rewardsOptions', []);
    }
}
__decorate([
    mobx_1.observable
], FleetQuoteStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], FleetQuoteStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], FleetQuoteStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.observable
], FleetQuoteStore.prototype, "appliedPromoCode", void 0);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "hasNoData", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "fleetQuote", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "hasAllDiscount", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "hasOnlineDiscount", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "hasAnyDiscount", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "quoteId", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "expiry", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "expiryMins", null);
__decorate([
    mobx_1.computed
], FleetQuoteStore.prototype, "rewardsOptions", null);
__decorate([
    mobx_1.action.bound
], FleetQuoteStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], FleetQuoteStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], FleetQuoteStore.prototype, "setAppliedPromoCode", void 0);
__decorate([
    mobx_1.action.bound
], FleetQuoteStore.prototype, "updateInitialState", void 0);
exports.default = FleetQuoteStore;
